import { useRef, useEffect } from 'react'
import styles from './TerminalInput.module.css'

interface TerminalInputProps {
  input: string
  setInput: (value: string) => void
  commandHistory: string[]
  historyIndex: number
  setHistoryIndex: (index: number) => void
  onCommand: (cmd: string) => void
}

export function TerminalInput({
  input,
  setInput,
  commandHistory,
  historyIndex,
  setHistoryIndex,
  onCommand,
}: TerminalInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (input.trim()) {
      onCommand(input)
      setInput('')
      setHistoryIndex(-1)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      if (commandHistory.length > 0) {
        const newIndex = historyIndex === -1 
          ? commandHistory.length - 1 
          : Math.max(0, historyIndex - 1)
        setHistoryIndex(newIndex)
        setInput(commandHistory[newIndex])
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault()
      if (historyIndex !== -1) {
        const newIndex = historyIndex + 1
        if (newIndex >= commandHistory.length) {
          setHistoryIndex(-1)
          setInput('')
        } else {
          setHistoryIndex(newIndex)
          setInput(commandHistory[newIndex])
        }
      }
    }
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <span className={styles.prompt}>$</span>
      <input
        ref={inputRef}
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        className={styles.input}
        autoFocus
        spellCheck={false}
      />
    </form>
  )
}

